import resolveSeatTranslation
    from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/resolveSeatTranslation';

function compileSeatTranslation(seat, seatCount) {
    if (seat.transformation.translation.manual) {
        return seat;
    }

    let translation = {
        x: 0,
        y: 0,
        manual: false,
        arc: false,
    };

    if (seat.row) {
        translation = resolveSeatTranslation(
            seat,
            null,
        );
    }
    if (seat.roundTable) {
        translation = resolveSeatTranslation(
            seat,
            seatCount || seat.roundTable.seats.count(),
        );
    }
    if (seat.rectangleTable) {
        translation = resolveSeatTranslation(
            seat,
            null,
        );
    }

    seat.transformation = {
        ...seat.transformation,
        translation,
    };

    return seat;
}

export default compileSeatTranslation;
